export function splitString(string: string) {
  return string.split(/\W+/);
}
